var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header colorHeader"},[_c('h2',{style:([
    !_vm.hasToken
      ? { right: '50px' }
      : _vm.isMobile
        ? {
          right: 0,
          'text-overflow': 'ellipsis',
          overflow: 'hidden',
          'text-wrap': 'nowrap',
          width: 'calc(100% - 90px)',
          display: 'block',
          'margin-right': '30px'
        }
        : { right: '330px' },
  ]),attrs:{"id":"title"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-btn',{staticClass:"home-button",attrs:{"color":"cyan white--text","rounded":""},on:{"click":_vm.goToIndex}},[_c('font-awesome-icon',{attrs:{"icon":"home","size":"lg"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }